import {
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
} from '@angular/core';

import {
  BannerImageFraming,
  BannerImagePlacement,
  bannerImagePlacement,
  normalizeBannerImageFraming,
} from './banner-image-framing';

@Component({
  selector: 'app-banner-image',
  standalone: true,
  template: `
    <img
      [src]="src"
      [alt]="alt"
      [style.object-fit]="imageFit"
      [style.object-position]="imagePosition"
      [style.transform]="imageTransform"
      [style.transform-origin]="imagePosition"
      (load)="onImageLoad($event)"
      decoding="async"
      draggable="false"
    />
  `,
  styles: [
    `
      :host {
        position: absolute;
        inset: 0;
        display: block;
        overflow: hidden;
        background: #e8edf5;
      }
      img {
        position: absolute;
        inset: 0;
        display: block;
        width: 100%;
        height: 100%;
        max-width: none;
        user-select: none;
        pointer-events: none;
      }
    `,
  ],
})
export class BannerImageComponent implements OnChanges {
  @Input() src = '';
  @Input() alt = '';
  @Input() framing: BannerImageFraming | null | undefined;

  private naturalWidth = 0;
  private naturalHeight = 0;
  imageFit = 'cover';
  imagePosition = '50% 50%';
  imageTransform = 'scale(1)';

  constructor(private host: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['src']) {
      this.naturalWidth = 0;
      this.naturalHeight = 0;
    }
    if (changes['framing']) {
      const framing = normalizeBannerImageFraming(this.framing);
      this.imageFit = framing.fit.toLowerCase();
      this.imagePosition = `${framing.positionX}% ${framing.positionY}%`;
      this.imageTransform = `scale(${framing.zoom})`;
    }
  }

  onImageLoad(event: Event): void {
    const image = event.target as HTMLImageElement;
    this.naturalWidth = image.naturalWidth;
    this.naturalHeight = image.naturalHeight;
  }

  get placement(): BannerImagePlacement | null {
    const frame = this.host.nativeElement;
    return bannerImagePlacement(
      frame.clientWidth,
      frame.clientHeight,
      this.naturalWidth,
      this.naturalHeight,
      this.framing
    );
  }
}
